import { divide } from "lodash";
import * as api from "../../services/api";
import {
  ACCEPT_JOB,
  CLEAR_POSTS,
  CLEAR_SEARCH,
  GET_POST,
  GET_POSTS,
  GET_POSTS_SEARCH,
  GET_POST_BY_ID,
  GET_TALENTS,
} from "../constants";

const getPosts =
  (companyId, status, setPlayAnimation, setPosts) => async (dispatch) => {
    setPlayAnimation(true);
    try {
      const response = await api.getPosts(companyId, status);
      dispatch({
        type: GET_POSTS,
        payload: response.data.data,
      });
      setPosts(response.data.data);
      setPlayAnimation(false);
    } catch (error) {
      setPlayAnimation(false);
      // console.log(error);
    }
  };

const getPostsByFilters =
  (filter, page = 1) =>
  async (dispatch) => {
    try {
      const response = await api.filterJobs(filter, page);
      dispatch({
        type: GET_POSTS_SEARCH,
        payload: response.data.data,
      });
    } catch (error) {
      // console.log(error);
    }
  };

const getPostsForStudent = (page, setLoading) => async (dispatch) => {
  if (!setLoading) return;
  setLoading(true);
  try {
    const response = await api.getAllActivePosts(page);

    setLoading(false);

    if (response.data.data) {
      dispatch({
        type: GET_POSTS,
        payload: response.data.data,
      });
    }
  } catch (error) {
    setLoading(false);
    // console.log(error);
  }
};

const getPostById = (id) => async (dispatch) => {
  try {
    const response = await api.getJobById(id);

    if (response.data.data) {
      dispatch({
        type: GET_POST,
        payload: response.data.data,
      });
    }
  } catch (error) {
    // console.log(error);
  }
};

const clearSearch = () => (dispatch) => {
  dispatch({
    type: CLEAR_SEARCH,
  });
};

const clearPosts = () => ({
  type: CLEAR_POSTS,
});

const acceptJob = () => async (dispatch) => {
  dispatch({
    type: ACCEPT_JOB,
    payload: true,
  });
};

const posts = {
  getPosts,
  getPostsByFilters,
  getPostsForStudent,
  getPostById,
  clearPosts,
  acceptJob,
  clearSearch,
};

export default posts;
